<template>
  <span>
    <Dialog class="test-box" :header="headerDialog" :visible.sync="showRemoverIntermediario" :modal="true"
      :closable="false">
      <div class="container">
        <div class="row">
          <div class="col-md-12 mb-2 mensagem-cancelamento">
            <p>
              {{
                "O Intermediário" +
                  " " +
                  (this.pessoa ? this.pessoa.detail : "") +
                  " será removido."
              }}
            </p>
            <p>
              {{ "Deseja continuar?" }}
            </p>
          </div>
        </div>
      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button @click="removerIntermediario()" href="#topo" type="button" label="Remover"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
          </div>

          <div>
            <Button @click="showRemoverIntermediario = false" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
  </span>
</template>

<script>
import NfsPessoaService from "@/services/nfse/pessoa.service";

export default {
  name: "RemoverIntermediario",

  // props: {
  //   tipoEmissao: String
  // },

  created() {
    this.$root.$on("notaFiscal:removerIntermediario", () => {
      this.pessoa = this.$parent.selectedPessoaIntermediario;
      console.log(this.pessoa)
      this.exibirDialogRemoverIntermediario();
    });
  },

  data() {
    return {
      showRemoverIntermediario: false,
      pessoa: null
    };
  },

  methods: {
    exibirDialogRemoverIntermediario() {
      this.showRemoverIntermediario = true;
    },

    removerIntermediario() {
      if (this.pessoa && this.pessoa.id) {
        this.$parent.processando(true);
        this.$parent.erros = [];

        NfsPessoaService.remove(this.pessoa.id)
          .then(
            data => {
              console.log(data);
              this.$root.$emit(
                "alert:success",
                "O Intermediario foi removido!"
              );
            },
            error => {
              console.log(error);
              this.$root.$emit(
                "alert:success",
                "Houve um problema ao remover o Intermediario!"
              );
            }
          )
          .then(() => {
            this.$parent.selectedPessoaIntermediario = null;
            this.showRemoverIntermediario = false;
            this.$parent.processando(false);
          });
      }
    }
  },

  computed: {
    headerDialog() {
      return "Remover Intermediario";
    },

    loading() {
      return this.$parent.loading;
    }
  }
};
</script>

<style scoped></style>
